<template>
  <v-overlay :value="overlay" absolute class="loading-overlay">
    <div class="d-flex align-center" style="height: 100vh;">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>
  </v-overlay>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-analytics",
  props: ['pageName', 'assetId', 'structureId', 'transactionId', 'challengeId'],
  data() {
    return {
      overlay: false,
      eventData: {}
    }
  },

  mounted() {
    this.postPageOpened()

    this.$root.$on('post-vimeo-webinar-progress', (data) => {
        this.postVimeoWebinarProgress(data)
    })
      
    this.$root.$on('post-vimeo-video-progress', (data) => {
      this.postVimeoVideoProgress(data) 
    })

    this.$root.$on('post-vimeo-video-completed', (data) => {
      this.postVimeoVideoCompleted(data)
    })

    this.$root.$on('post-pdf-opened', () => {
      this.postPdfOpened()
    })

    this.$root.$on('post-survey-opened', () => {
      this.postSurveyOpened()
    })

    this.$root.$on('post-event-opened', (data) => {
        this.postEventOpened(data)
    })

    this.$root.$on('post-challenge-opened', (data) => {
        this.postChallengeOpened(data)
    })

    this.$root.$on('post-news-opened', (data) => {
        this.postNewsOpened(data)
    })
  },
  
  methods: {
    initEventData(cat, type){
      let datetimeUser = this.$moment().format()
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
      
      this.eventData = {
        EventCategory: cat,
        EventType: type,
        DateTimeUser: datetimeUser,
        TimeZoneUser: tz
      }
    },
    
    async postPageOpened(){
      this.initEventData("page", "page_opened")
      
      this.eventData.PageUrl = window.location.pathname
      this.eventData.PageName = this.pageName
      
      if (this.assetId){ this.eventData.AssetId = this.assetId }
      if (this.structureId){ this.eventData.structureId = this.structureId }
      if (this.challengeId){ this.eventData.challengeId = this.challengeId }

      await api.eventLogs.postEvent(this.eventData)
    },

      async postVimeoWebinarProgress(data){
          this.initEventData("vimeo", "webinar_progress")

          if (this.assetId){ this.eventData.AssetId = this.assetId }
          if (this.structureId){ this.eventData.structureId = this.structureId }
          if (this.challengeId){ this.eventData.challengeId = this.challengeId }
          if (this.transactionId){ this.eventData.TransactionId = this.transactionId }
          if (data.videoPercentageWatched){ this.eventData.VideoPercentageWatched = data.videoPercentageWatched }
          if (data.videoTimeWatched){ this.eventData.VideoTimeWatched = data.videoTimeWatched }
          if (data.videoDuration){ this.eventData.VideoDuration = data.videoDuration }

          await api.eventLogs.postEvent(this.eventData)
      },
    
    async postVimeoVideoProgress(data){
      this.initEventData("vimeo", "video_progress")

      if (this.assetId){ this.eventData.AssetId = this.assetId }
      if (this.structureId){ this.eventData.structureId = this.structureId }
      if (this.challengeId){ this.eventData.challengeId = this.challengeId }
      if (this.transactionId){ this.eventData.TransactionId = this.transactionId }
      if (data.videoPercentageWatched){ this.eventData.VideoPercentageWatched = data.videoPercentageWatched }
      if (data.videoTimeWatched){ this.eventData.VideoTimeWatched = data.videoTimeWatched }
      if (data.videoDuration){ this.eventData.VideoDuration = data.videoDuration }

      await api.eventLogs.postEvent(this.eventData)
    },

    async postVimeoVideoCompleted(data){
      this.initEventData("vimeo", "video_completed")

      if (this.assetId){ this.eventData.AssetId = this.assetId }
      if (this.structureId){ this.eventData.structureId = this.structureId }
      if (this.challengeId){ this.eventData.challengeId = this.challengeId }
      if (this.transactionId){ this.eventData.TransactionId = this.transactionId }
      if (data.videoPercentageWatched){ this.eventData.VideoPercentageWatched = data.videoPercentageWatched }
      if (data.videoTimeWatched){ this.eventData.VideoTimeWatched = data.videoTimeWatched }
      if (data.videoDuration){ this.eventData.VideoDuration = data.videoDuration }

      await api.eventLogs.postEvent(this.eventData)
    },

    async postPdfOpened(){
      this.initEventData("pdf", "pdf_opened")

      if (this.assetId){ this.eventData.AssetId = this.assetId }
      if (this.structureId){ this.eventData.structureId = this.structureId }

      await api.eventLogs.postEvent(this.eventData)
    },

    async postSurveyOpened(){
      this.initEventData("survey", "survey_opened")

      if (this.assetId){ this.eventData.AssetId = this.assetId }
      if (this.structureId){ this.eventData.structureId = this.structureId }

      await api.eventLogs.postEvent(this.eventData)
    },

    async postEventOpened(data){
        this.initEventData("newsitem", "event_opened")

        /*if (this.assetId){ this.eventData.AssetId = this.assetId }
        if (this.structureId){ this.eventData.structureId = this.structureId }*/
        this.eventData.PageUrl = window.location.pathname
        this.eventData.PageName = this.pageName
        if (data.id){ this.eventData.NewsItemId = data.id }

        await api.eventLogs.postEvent(this.eventData)
    },

    async postChallengeOpened(data){
        this.initEventData("newsitem", "challenge_opened")

        /*if (this.assetId){ this.eventData.AssetId = this.assetId }
        if (this.structureId){ this.eventData.structureId = this.structureId }*/
        this.eventData.PageUrl = window.location.pathname
        this.eventData.PageName = this.pageName
        if (data.id){ this.eventData.NewsItemId = data.id }

        await api.eventLogs.postEvent(this.eventData)
    },
      
    async postNewsOpened(data){
      this.initEventData("newsitem", "news_opened")

      /*if (this.assetId){ this.eventData.AssetId = this.assetId }
      if (this.structureId){ this.eventData.structureId = this.structureId }*/
      this.eventData.PageUrl = window.location.pathname
      this.eventData.PageName = this.pageName
      if (data.id){ this.eventData.NewsItemId = data.id }

      await api.eventLogs.postEvent(this.eventData)
    }
  }
}
</script>

<style lang="scss">
</style>
